
import React from 'react';
// import PropTypes from 'prop-types';
import Select from '@material-ui/core/Select';
import FormControl from '@material-ui/core/FormControl'
import InputLabel from '@material-ui/core/InputLabel'
import { MenuItem } from '@material-ui/core';

const RenderSelectFieldRedux = props => {
  const { label, data, input } = props
  // console.log('props', props)
  return  <FormControl variant="outlined" style={{minWidth: '100%'}}>
          <InputLabel id="demo-simple-select-outlined-label" style={{color : "#000000"}}>{label}</InputLabel>
            <Select
            label={label}
            labelId="demo-simple-select-label"
            {...input} 
            // value={selectedAccount}
            >
                {
                    data.map(option => {
                      return <MenuItem key={option.id || option.codigo || option.secuencial || option.uuid || option.secuencialInstitucion  } value={option.value || option.spi_code || option.codigo || option.secuencial || option.secuencialInstitucion}>{`${option.text || option.institution_name || option.nombre || option.name || option.nombreInstitucion}`}</MenuItem>
                    })
                }
            </Select>
        </FormControl>
}

/* renderSelectField.propTypes = {
     
}; */

export default RenderSelectFieldRedux;